export default __webpack_public_path__ + "static/media/chevron-left.7de23d6d.svg";